import { sva } from "@agapi/ui/panda/css";

export const alertBannerStyles = sva({
  slots: ['root', 'item','label'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      md: {
        flexDirection: 'row'
      }
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      py: '2',
      textAlign: 'center',
      px: 'app',
    },
    label: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center'
    }
  }
});
